import React from 'react';

export const PrereceivedIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 251.46 236.34"
        style={{ width: '40px', height: '40px', fill: 'rgb(231, 45, 97)', stroke: 'rgb(231, 45, 97)' }}
    >
        <defs>
            <style>{`.skl-c30-1,.skl-c30-3{fill:none;}.skl-c30-1{stroke-miterlimit:10;stroke-width:10px;}.skl-c30-2{}.skl-c30-3{stroke-width:4px;}.skl-c30-3,.skl-c30-4{stroke-linecap:round;stroke-linejoin:round;}.skl-c30-4{stroke:#fff;stroke-width:8px;}`}</style>
        </defs>
        <g id="Vrstva_2" data-name="Vrstva 2">
            <g id="Vrstva_1-2" data-name="Vrstva 1">
                <circle className="skl-c30-1" cx="116.32" cy="116.32" r="111.32"></circle>
                <circle cx="197.55" cy="182.43" r="53.91"></circle>
                <path className="skl-c30-2" d="M59.49,126H88.41v4.83H59.49Z"></path>
                <path className="skl-c30-2" d="M59.49,135.63h4.82v4.82H59.49Z"></path>
                <path className="skl-c30-2" d="M69.13,135.63H88.41v4.82H69.13Z"></path>
                <path className="skl-c30-2" d="M58.49,144.27H87.41v4.82H58.49Z"></path>
                <path className="skl-c30-2" d="M58.49,153.91H87.41v4.82H58.49Z"></path>
                <path className="skl-c30-2" d="M82.59,163.55h4.82v4.82H82.59Z"></path>
                <path className="skl-c30-2" d="M58.49,163.55H77.77v4.82H58.49Z"></path>
                <path
                    className="skl-c30-2"
                    d="M71.54,68.14A2.41,2.41,0,0,1,74,65.73H85l-5.52,5.52,3.41,3.41L94.23,63.32,82.89,52l-3.41,3.41L85,60.91H74a7.23,7.23,0,0,0-7.23,7.23v39.47h4.82Z"
                ></path>
                <path
                    className="skl-c30-2"
                    d="M110.5,106a8.39,8.39,0,0,0,8.35,8.42,8.54,8.54,0,0,0,6-2.47,8.29,8.29,0,0,0,2.51-6,8.37,8.37,0,0,0-2.51-6,8.5,8.5,0,0,0-6-2.47A8.39,8.39,0,0,0,110.5,106Zm3.74,0a4.64,4.64,0,0,1,4.61-4.68,4.68,4.68,0,1,1,0,9.36A4.65,4.65,0,0,1,114.24,106Z"
                ></path>
                <path
                    className="skl-c30-2"
                    d="M110.42,75.94V86.22a1.88,1.88,0,0,0,1.88,1.87h15.23a1.87,1.87,0,0,0,1.87-1.87V70.87A1.87,1.87,0,0,0,127.53,69h-9.6a1.79,1.79,0,0,0-1.25.49L111,74.56A1.87,1.87,0,0,0,110.42,75.94Zm3.75.83,4.49-4h7V84.35H114.17Z"
                ></path>
                <path
                    className="skl-c30-2"
                    d="M156.21,106a8.39,8.39,0,0,0,8.35,8.42,8.54,8.54,0,0,0,6-2.47,8.29,8.29,0,0,0,2.51-6,8.37,8.37,0,0,0-2.51-6,8.5,8.5,0,0,0-6-2.47A8.39,8.39,0,0,0,156.21,106Zm3.74,0a4.64,4.64,0,0,1,4.61-4.68,4.68,4.68,0,1,1,0,9.36A4.65,4.65,0,0,1,160,106Z"
                ></path>
                <path
                    className="skl-c30-2"
                    d="M175.17,101.72a1.87,1.87,0,0,0,1.87,1.87h5.64a1.87,1.87,0,0,0,1.87-1.87V94.87a1.88,1.88,0,1,0-3.75,0v5H177A1.87,1.87,0,0,0,175.17,101.72Z"
                ></path>
                <path
                    className="skl-c30-2"
                    d="M102.08,73.32l.15,28.38a1.86,1.86,0,0,0,1.87,1.85h3.8a1.87,1.87,0,0,0,0-3.74h-2l-.13-25.63L118,64.08h15.09V99.85h-3.76a1.87,1.87,0,1,0,0,3.74H152.2a1.87,1.87,0,0,0,0-3.74H136.85V55.47h44v39a1.88,1.88,0,0,0,3.75,0V53.59a1.87,1.87,0,0,0-1.87-1.87H135a1.87,1.87,0,0,0-1.87,1.87v6.74H117.37a1.86,1.86,0,0,0-1.2.43l-13.4,11.1h0A2,2,0,0,0,102.08,73.32Z"
                ></path>
                <rect className="skl-c30-3" x="50.75" y="116.01" width="45.49" height="62.97"></rect>
                <polyline className="skl-c30-4" points="196.13 152.87 195.8 194.21 223.66 180.95"></polyline>
            </g>
        </g>
    </svg>
);

export const InprocessIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 255.1 254.87"
        style={{ width: '40px', height: '40px', fill: 'rgb(220, 220, 220)', stroke: 'rgb(220, 220, 220)' }}
    >
        <defs>
            <style>{`.skl-c3-1{fill:none;}.skl-c3-2{clip-path-3:url(#clip-path-3);}.skl-c3-3{}`}</style>
            <clipPath id="clip-path-3" transform="translate(-22.37 -21.7)">
                <rect className="skl-c3-1" x="75.59" y="69.4" width="145.41" height="158.71"></rect>
            </clipPath>
        </defs>
        <g className="skl-c3-2">
            <path
                d="M220.94,107a4.27,4.27,0,0,0-.4-1.77,3.88,3.88,0,0,0-2.7-2.13L149.93,70.16a4.05,4.05,0,0,0-3.5,0L77.86,103.4a4,4,0,0,0-2.27,3.47v83.57a4,4,0,0,0,2.27,3.6l68.57,33.24s0,0,.07,0a1.3,1.3,0,0,1,.3.13s.06,0,.13,0l.3.1.1,0c.1,0,.23,0,.34.07h.09l.44,0a2.08,2.08,0,0,0,.43,0h.1a1.47,1.47,0,0,0,.34-.07l.09,0,.31-.1s.06,0,.13,0a1,1,0,0,0,.3-.13s0,0,.07,0l68.77-33.34a4,4,0,0,0,2.27-3.6V107.1a.09.09,0,0,1-.07-.1ZM148.16,78.2,207.64,107l-21.91,10.64L126.26,88.83Zm0,57.67L88.69,107,117.1,93.27l59.47,28.83Zm-64.57-22.4,60.57,29.37v74.44L83.59,187.91Zm68.58,103.81V142.84L180.6,129V148.5a4,4,0,0,0,8,0V125.14l24.34-11.81v74.44Zm0,0"
                transform="translate(-22.37 -21.7)"
            ></path>
        </g>
        <path
            className="skl-c3-3"
            d="M36.94,109.69C44.55,93.33,54.59,75.85,68,63.52A125.38,125.38,0,0,1,112.7,37.38C154,23.81,200.51,35.31,231.21,65.85a123.66,123.66,0,0,1,27.94,42.65c2.31,5.93,12,3.35,9.65-2.66C254.49,69,224.57,39.46,186.62,27.54a127.19,127.19,0,0,0-67.29-2.44C99,30,80.16,40.44,64.1,53.73c-15.72,13-27.3,32.65-35.8,50.92-2.69,5.8,5.92,10.88,8.64,5Z"
            transform="translate(-22.37 -21.7)"
        ></path>
        <path
            className="skl-c3-3"
            d="M28.3,193.68c10.6,19.43,20.84,39,38.34,53.18,16.68,13.55,37,23.53,58.18,27.53a127.74,127.74,0,0,0,114.49-36,136.8,136.8,0,0,0,29.49-45.86c2.35-6-7.32-8.59-9.65-2.66-12.34,31.5-38,57.85-69.89,69.52-37.39,13.68-78.13,7.19-110.46-15.7-19.75-14-30.55-34.27-41.86-55-3.08-5.65-11.72-.61-8.64,5.05Z"
            transform="translate(-22.37 -21.7)"
        ></path>
        <path
            className="skl-c3-3"
            d="M238.76,97.7,262,114.44c2.72,2,6.49-.16,7.35-3l7.86-25.95c1.88-6.18-7.77-8.81-9.64-2.66l-7.86,26,7.34-3L243.81,89.07c-5.23-3.77-10.23,4.9-5.05,8.63Z"
            transform="translate(-22.37 -21.7)"
        ></path>
        <path
            className="skl-c3-3"
            d="M32.4,213.63l3-27.27-7.52,4.32,23.82,12.65c5.68,3,10.74-5.61,5.05-8.64L32.88,182.05c-3.59-1.91-7.11.54-7.52,4.31l-3,27.27c-.69,6.39,9.32,6.34,10,0Z"
            transform="translate(-22.37 -21.7)"
        ></path>
    </svg>
);

export const OnthewayIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 259.75 259.78"
        style={{ width: '40px', height: '40px', fill: 'rgb(220, 220, 220)', stroke: 'rgb(220, 220, 220)' }}
    >
        <defs>
            <style>{`.skl-c6-1{}`}</style>
        </defs>
        <path
            d="M203.41,175.87a16.08,16.08,0,0,0-11.35,4.69,15.76,15.76,0,0,0,0,22.57,16.13,16.13,0,0,0,11.35,4.69,16,16,0,0,0,0-31.95Zm0,24.85a8.88,8.88,0,1,1,0-17.75,8.88,8.88,0,0,1,0,17.75Zm0,0"
            transform="translate(-21.31 -18.51)"
        ></path>
        <path
            d="M207.53,122.66a3.46,3.46,0,0,0-2.38-.92H186.94a3.56,3.56,0,0,0-3.55,3.55V154.4a3.56,3.56,0,0,0,3.55,3.55h28.9a3.56,3.56,0,0,0,3.55-3.55V134.91a3.58,3.58,0,0,0-1.17-2.63Zm4.76,28.19h-21.8v-22h13.28l8.52,7.67Zm0,0"
            transform="translate(-21.31 -18.51)"
        ></path>
        <path
            d="M116.73,175.87a16.09,16.09,0,0,0-11.36,4.69,15.87,15.87,0,0,0-4.76,11.29,15.68,15.68,0,0,0,4.76,11.28,16.16,16.16,0,0,0,11.36,4.69,16,16,0,0,0,0-31.95Zm0,24.85a8.88,8.88,0,1,1,0-17.75,8.88,8.88,0,0,1,0,17.75Zm0,0"
            transform="translate(-21.31 -18.51)"
        ></path>
        <path
            d="M93.05,180.24H85.92v-9.45a3.55,3.55,0,0,0-7.1,0v13a3.56,3.56,0,0,0,3.55,3.55H93.05a3.55,3.55,0,0,0,0-7.1Zm0,0"
            transform="translate(-21.31 -18.51)"
        ></path>
        <path
            d="M111.05,160.89a3.56,3.56,0,0,0-3.55-3.55H64.44a3.55,3.55,0,0,0,0,7.1H107.5a3.54,3.54,0,0,0,3.55-3.55Zm0,0"
            transform="translate(-21.31 -18.51)"
        ></path>
        <path
            d="M71.65,148.08l43.06.25a3.58,3.58,0,0,0,3.58-3.52,3.51,3.51,0,0,0-3.51-3.58L71.72,141h0a3.55,3.55,0,0,0,0,7.1Zm0,0"
            transform="translate(-21.31 -18.51)"
        ></path>
        <path
            d="M78.89,132H122a3.55,3.55,0,0,0,0-7.1H78.89a3.55,3.55,0,1,0,0,7.1Zm0,0"
            transform="translate(-21.31 -18.51)"
        ></path>
        <path
            d="M233.91,127.17l-25.42-21a3.51,3.51,0,0,0-2.27-.82H176.33V92.52A3.56,3.56,0,0,0,172.78,89H82.37a3.56,3.56,0,0,0-3.55,3.55v26a3.55,3.55,0,1,0,7.1,0V96.07h83.34v84.17h-29.1a3.55,3.55,0,1,0,0,7.1H183.5a3.55,3.55,0,1,0,0-7.1h-7.14V112.4H205l23.14,19.17-.25,48.6h-3.69a3.55,3.55,0,0,0,0,7.1h7.21a3.53,3.53,0,0,0,3.54-3.52l.29-53.81a3.77,3.77,0,0,0-1.31-2.77Zm0,0"
            transform="translate(-21.31 -18.51)"
        ></path>
        <path
            className="skl-c6-1"
            d="M271.05,148.4c-.27,49.67-31.61,95.57-78.54,112.66-47.44,17.28-101.43,2.67-133.8-36S22.27,129.77,48.11,86.7s77.14-65.9,126.31-56c48.92,9.8,87.3,49.84,95.22,99.06a121.61,121.61,0,0,1,1.41,18.68c0,6.43,10,6.44,10,0-.29-54.13-34.42-103.27-85.26-122.08-51-18.88-110.51-2.7-145,39.35-34.61,42.21-39.39,103.21-11,150,28.28,46.6,83.89,70.78,137.27,60.08,52.19-10.46,94.14-54.09,102.31-106.72a138.8,138.8,0,0,0,1.66-20.66C281.09,142,271.09,142,271.05,148.4Z"
            transform="translate(-21.31 -18.51)"
        ></path>
    </svg>
);

export const DeliveredIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 260.24 259.78"
        style={{ width: '40px', height: '40px', fill: 'rgb(220, 220, 220)', stroke: 'rgb(220, 220, 220)' }}
    >
        <defs>
            <style>{`.skl-c2-1{}.skl-c2-2{fill:#fff;}`}</style>
        </defs>
        <path
            d="M203.41,175.87a16.08,16.08,0,0,0-11.35,4.69,15.76,15.76,0,0,0,0,22.57,16.13,16.13,0,0,0,11.35,4.69,16,16,0,0,0,0-31.95Zm0,24.85a8.88,8.88,0,1,1,0-17.75,8.88,8.88,0,0,1,0,17.75Zm0,0"
            transform="translate(-20.82 -18.51)"
        ></path>
        <path
            d="M207.53,122.66a3.46,3.46,0,0,0-2.38-.92H186.94a3.56,3.56,0,0,0-3.55,3.55V154.4a3.56,3.56,0,0,0,3.55,3.55h28.9a3.56,3.56,0,0,0,3.55-3.55V134.91a3.58,3.58,0,0,0-1.17-2.63Zm4.76,28.19h-21.8v-22h13.28l8.52,7.67Zm0,0"
            transform="translate(-20.82 -18.51)"
        ></path>
        <path
            d="M116.73,175.87a16.09,16.09,0,0,0-11.36,4.69,15.87,15.87,0,0,0-4.76,11.29,15.68,15.68,0,0,0,4.76,11.28,16.16,16.16,0,0,0,11.36,4.69,16,16,0,0,0,0-31.95Zm0,24.85a8.88,8.88,0,1,1,0-17.75,8.88,8.88,0,0,1,0,17.75Zm0,0"
            transform="translate(-20.82 -18.51)"
        ></path>
        <path
            d="M93.05,180.24H85.92v-9.45a3.55,3.55,0,0,0-7.1,0v13a3.56,3.56,0,0,0,3.55,3.55H93.05a3.55,3.55,0,0,0,0-7.1Zm0,0"
            transform="translate(-20.82 -18.51)"
        ></path>
        <path
            d="M111.05,160.89a3.56,3.56,0,0,0-3.55-3.55H64.44a3.55,3.55,0,0,0,0,7.1H107.5a3.54,3.54,0,0,0,3.55-3.55Zm0,0"
            transform="translate(-20.82 -18.51)"
        ></path>
        <path
            d="M71.65,148.08l43.06.25a3.58,3.58,0,0,0,3.58-3.52,3.51,3.51,0,0,0-3.51-3.58L71.72,141h0a3.55,3.55,0,0,0,0,7.1Zm0,0"
            transform="translate(-20.82 -18.51)"
        ></path>
        <path
            d="M78.89,132H122a3.55,3.55,0,0,0,0-7.1H78.89a3.55,3.55,0,1,0,0,7.1Zm0,0"
            transform="translate(-20.82 -18.51)"
        ></path>
        <path
            d="M233.91,127.17l-25.42-21a3.51,3.51,0,0,0-2.27-.82H176.33V92.52A3.56,3.56,0,0,0,172.78,89H82.37a3.56,3.56,0,0,0-3.55,3.55v26a3.55,3.55,0,1,0,7.1,0V96.07h83.34v84.17h-29.1a3.55,3.55,0,1,0,0,7.1H183.5a3.55,3.55,0,1,0,0-7.1h-7.14V112.4H205l23.14,19.17-.25,48.6h-3.69a3.55,3.55,0,0,0,0,7.1h7.21a3.53,3.53,0,0,0,3.54-3.52l.29-53.81a3.77,3.77,0,0,0-1.31-2.77Zm0,0"
            transform="translate(-20.82 -18.51)"
        ></path>
        <path
            className="skl-c2-1"
            d="M271.05,148.4c-.27,49.67-31.61,95.57-78.54,112.66-47.44,17.28-101.43,2.67-133.8-36S22.27,129.77,48.11,86.7s77.14-65.9,126.31-56c48.92,9.8,87.3,49.84,95.22,99.06a121.61,121.61,0,0,1,1.41,18.68c0,6.43,10,6.44,10,0-.29-54.13-34.42-103.27-85.26-122.08-51-18.88-110.51-2.7-145,39.35-34.61,42.21-39.39,103.21-11,150,28.28,46.6,83.89,70.78,137.27,60.08,52.19-10.46,94.14-54.09,102.31-106.72a138.8,138.8,0,0,0,1.66-20.66C281.09,142,271.09,142,271.05,148.4Z"
            transform="translate(-20.82 -18.51)"
        ></path>
        <circle className="skl-c2-1" cx="55.98" cy="202.06" r="55.98"></circle>
        <path
            className="skl-c2-2"
            d="M55,228.83,65.88,246c1.92,3,6.82,3.46,8.64,0l24.09-45.9c3-5.69-5.64-10.75-8.63-5L65.88,241h8.64L63.61,223.78c-3.43-5.42-12.09-.41-8.63,5.05Z"
            transform="translate(-20.82 -18.51)"
        ></path>
    </svg>
);
